import backForDocMalta from "@/src/assets/admissionOfficePage/back-for-doc-malta.webp";
import backForDocPoland from "@/src/assets/admissionOfficePage/back-for-doc-poland.webp";
import backForDocUkraine from "@/src/assets/admissionOfficePage/back-for-doc-ukraine.webp";
import backForDocUkraineFeu from "@/src/assets/admissionOfficePage/back-for-doc-ukraine-feu.png";
import backForDocMaltaNoQr from "@/src/assets/admissionOfficePage/back-for-doc-malta-no-qr.png";
import backForDocUkraineNoQr from "@/src/assets/admissionOfficePage/back-for-doc-ukraine-no-qr.png";
import backForDocUkraineFeuNoQr from "@/src/assets/admissionOfficePage/back-for-doc-ukraine-feu-no-qr.png";
import type { AdmissionOfficeCountry } from "@/src/components/AdmissionsOfficePage/admissionOfficeCountry";
import { isFeuComUaOffice } from "@/src/utils/accessControl/formatOfficeUrl";

const BACKGROUNDS: Record<AdmissionOfficeCountry, string> = {
  malta: backForDocMalta,
  poland: backForDocPoland,
  ukraine: backForDocUkraine,
};

const NO_QR_BACKGROUNDS: Partial<Record<AdmissionOfficeCountry, string>> = {
  malta: backForDocMaltaNoQr,
  ukraine: backForDocUkraineNoQr,
};

export const getAdmissionOfficePreviewBackground = (
  country: AdmissionOfficeCountry,
  withQR = true,
  officeUrl?: string | null,
) => {
  if (country === "ukraine" && isFeuComUaOffice(officeUrl)) {
    return withQR ? backForDocUkraineFeu : backForDocUkraineFeuNoQr;
  }

  if (!withQR) {
    const noQrBackground = NO_QR_BACKGROUNDS[country];
    if (noQrBackground) return noQrBackground;
  }

  return BACKGROUNDS[country];
};
